export const validChars = /^[ A-Za-z0-9_@./+"':+,=-?#!%()ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]*$/
